new window.Shopify.OptionSelectors('product-variants', {
	product: window.product,
	onVariantSelected: function (variant) {
		if (!variant) return;

		if ([...document.querySelectorAll('select[data-option-index]')].some(select => select.selectedIndex <= 0)) return;

		const price = document.getElementById('product-price')?.querySelector('span');
		const addToCart = document.getElementById('add-to-cart');

		if (price) {
			price.innerHTML = Shopify.formatMoney(variant.price, window.theme.moneyFormat);
			// ${variant.compare_at_price > variant.price ? `<span class="font-strike">${Shopify.formatMoney(variant.compare_at_price, '{{ shop.money_format }}')}</span>` : ``};
		}

		if (addToCart) {
			addToCart.disabled = !variant.available;
			addToCart.dataset.state = variant.available ? 'add' : 'sold';
		}
	}
});

document.querySelectorAll('select[data-option-index]').forEach(select => {
	select.addEventListener('change', function () {
		const index = this.dataset.optionIndex;
		const value = this.value;
		const option = this.closest('form')?.querySelectorAll('.single-option-selector')[index];
		if (!option) return;

		option.value = value;
		option.dispatchEvent(new Event('change', { bubbles: true }));

		const isMaterial = this.name === 'MATERIAL' || this.name === 'Material' || this.name === 'material';
		if (!isMaterial) return;

		const gallery = document.querySelector(`figure[data-gallery="${this.selectedIndex - 1}"]`);
		if (!gallery) return;

		document.querySelectorAll('figure[data-gallery]').forEach(g => g.hidden = true);
		gallery.hidden = false;
	});
});
